module.exports = __webpack_public_path__ + "static/img/solutionBanner.4fa77a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solutionBanner.png
// module id = erXA
// module chunks = 1